import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  constructor(private http: HttpClient) { }

  private buildHttpParams(params: any): HttpParams {
    if (!params) {
      return new HttpParams();
    }

    if (params instanceof HttpParams) {
      return params;
    }

    if (typeof params === 'string') {
      const trimmed = params.trim();
      if (!trimmed) {
        return new HttpParams();
      }
      return new HttpParams().set('param', trimmed);
    }

    if (typeof params === 'object') {
      const keys = Object.keys(params);
      if (keys.length === 0) {
        return new HttpParams();
      }

      let httpParams = new HttpParams();
      for (const key of keys) {
        const val = params[key];
        if (val !== null && val !== undefined && val !== '') {
          httpParams = httpParams.set(key, String(val));
        }
      }
      return httpParams;
    }

    return new HttpParams();
  }

  public get<T = any>(url: string, params?: any): Observable<T> {
    const httpParams = this.buildHttpParams(params);
    return this.http.get<T>(url, { params: httpParams });
  }

  public post<T = any>(url: string, body?: any): Observable<T> {
    return this.http.post<T>(url, body ?? {});
  }

  public put<T = any>(url: string, body?: any): Observable<T> {
    return this.http.put<T>(url, body ?? {});
  }

  public patch<T = any>(url: string, body?: any): Observable<T> {
    return this.http.patch<T>(url, body ?? {});
  }

  public delete<T = any>(url: string, params?: any): Observable<T> {
    const httpParams = this.buildHttpParams(params);
    return this.http.delete<T>(url, { params: httpParams });
  }

  public getBlob(url: string, params?: any): Observable<Blob> {
    const httpParams = this.buildHttpParams(params);
    return this.http.get(url, {
      params: httpParams,
      responseType: 'blob'
    });
  }

  public getBlob2(url: string, params?: any): Observable<Blob> {
    return this.getBlob(url, params);
  }

  public postBlob(url: string, params?: any): Observable<Blob> {
    return this.http.post(url, params, {
      responseType: 'blob'
    });
  }

  public postFormData<T = any>(url: string, params: any): Observable<T> {
    return this.http.post<T>(url, params);
  }

  public get_file_download(url: string, params?: any, name: string = ''): Observable<Blob> {
    return this.getBlob(url, params);
  }

  public postFileUpload<T = any>(url: string, params: any, name: string = ''): Observable<T> {
    return this.http.post<T>(url, params);
  }
}
